import { Wifi, HardDrive } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { RelayListManager } from '@/components/RelayListManager';
import { BlossomServerListManager } from '@/components/BlossomServerListManager';

interface NetworkDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Settings dialog for the network services Wikistar depends on: Nostr
 * relays (NIP-65, kind 10002) for reading/writing articles and
 * publications, and Blossom servers (BUD-03, kind 10063) for file
 * uploads. Opened from the "Network" item in the account/profile
 * dropdown (`AccountSwitcher`).
 */
export function NetworkDialog({ isOpen, onClose }: NetworkDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-h-[85dvh] overflow-y-auto sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Network</DialogTitle>
          <DialogDescription>
            Manage the relays and file servers Wikistar uses to read and publish content.
          </DialogDescription>
        </DialogHeader>

        <Tabs defaultValue="relays">
          <TabsList className="w-full">
            <TabsTrigger value="relays">
              <Wifi className="size-4" />
              Relays
            </TabsTrigger>
            <TabsTrigger value="blossom">
              <HardDrive className="size-4" />
              File servers
            </TabsTrigger>
          </TabsList>
          <TabsContent value="relays">
            <RelayListManager />
          </TabsContent>
          <TabsContent value="blossom">
            <BlossomServerListManager />
          </TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
}
